<template>
  <div>
    <Header />
    <Breadcrumbs title="Continue Shopping" />
    <div class="container">
      <CheckoutTitle title="shopping cart" />
      <div class="checkout-details" v-if="cart.items.length">
        <table class="table table-striped table-hover table-condensed">
          <thead>
            <tr>
              <th>Brand</th>
              <th class="text-center">Item</th>
              <th>Qty</th>
              <th>Price</th>
              <th>Total</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in cart.items" :key="index">
              <td>{{ item.brand }}</td>
              <td class="text-center">

                <template v-if="item.rebate_text">
                  <div>{{ item.productname_checkout }}</div><div class="promo_percent_text">{{ item.rebate_text }}</div>
                </template>
                <template v-else>
                  <div>{{ item.productname_checkout }}</div>
                </template>

              </td>
              <td>
                <div class="carts-box">
                  <div class="input-group">
                    <span class="input-group-prepend">
                      <button type="button" class="btn quantity-left-minus" data-type="minus" data-field
                        @click="decrement(item.sku, item.quantity - 1)">
                        <i class="ti-minus"></i>
                      </button>
                    </span>
                    <input type="text" name="quantity" class="form-control input-number" v-model="item.quantity"
                      @change="editqty(item.sku, item.quantity)" />
                    <span class="input-group-prepend">
                      <button type="button" class="btn quantity-right-plus" data-type="plus" data-field
                        @click="increment(item.sku, item.quantity + 1)">
                        <i class="ti-plus"></i>
                      </button>
                    </span>
                  </div>
                </div>
              </td>
              <td>${{ item.price_unit }}</td>
              <td><strong>{{ item.price_total }}</strong></td>
              <td>
                <img role="button" :src="require('@/assets/images/icon/close.png')" alt="icon"
                  @click='removeCartItem(item.sku)' />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="checkout-sub-total" v-if="cart.items.length">
        <h3>Subtotal = $ {{ cart.total_usd }}</h3>
      </div>
      <table class="table cart-table cart-list-table table-responsive-xs mt-5 t-foot" v-if="webTotalLines">
        <tfoot>
          <tr v-for="tax in webTotalLines" :key="tax.text">
            <td v-if="tax.type == 'taxesfees'" v-b-modal.modal-cart-detail>{{ tax.text }}</td>
            <td v-else>{{ tax.text }}</td>
            <td class="text-right">
              <div
                :style="tax.style == 'crossed' ? 'text-decoration: line-through;' : tax.style == 'bold' ? 'font-weight: bold;' : 'font-style: normal;'">
                {{ tax.value_show }}</div>
            </td>
          </tr>
        </tfoot>
      </table>


      <div class="col-sm-12 empty-cart-cls text-center mt-5" v-if="!cart.items.length">
        <h3 class="empty-cart-title mb-5">
          <strong>Your Cart is Empty!</strong>
        </h3>
        <div class="text-center mb-5">
          <router-link :to="{ path: '/shop' }" class="btn checkout-btn ml-5">Shop Now!</router-link>
        </div>
      </div>


      <template  v-if="cart.items.length">

        <template v-if="cart.special_never_ordered.active === 1">

<!--          todo: Jorge design as per Noah's-->
          <div>
            {{cart.special_never_ordered.promo_special.hello_name}}
            <br>
            {{cart.special_never_ordered.promo_special.product_name}}
            <br>
            <img v-if="cart.special_never_ordered.promo_special.image_src !== ''" :src="cart.special_never_ordered.promo_special.image_src" width="150" alt="no-image">
            ${{cart.special_never_ordered.promo_special.price_crossed}}
            ${{cart.special_never_ordered.promo_special.price_special}}
            <br>
            <button @click="add_promo_special_to_order(cart.special_never_ordered.promo_special.sku,cart.special_never_ordered.promo_special.promo_id)">ADD TO CART</button>
          </div>


        </template>

        

        <div class="row col-12 mx-0 px-0 justify-content-end align-items-center my-5">
          <!-- <router-link :to="{ path: '/shop' }" :class="'btn btn-update'">Update</router-link> -->
          <router-link v-if="!getBlockCheckout" :to="{ path: '/shop/checkout' }"
                       class="btn checkout-btn ml-5">Checkout</router-link>
        </div>
      </template>

      <hr class="mb-5" />
    </div>
    <b-modal id="modal-cart-detail" size="lg" centered :hide-footer="true">
      <div class="tax-fee-title">{{ webTotalTitle }}</div>
      <table style="border-bottom: 1px solid #bdbdbd; margin-bottom: 15px;" align="center">
        <thead>
          <tr>
            <td class="tax-fee-header">DETAIL</td>
            <td class="tax-fee-header">DESCRIPTION</td>
            <td class="tax-fee-header">PRICE</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(fee, index) in webTotalDetails" :key="index">
            <td>{{ fee.text }}</td>
            <td class="tf-margin">{{ fee.description }}</td>
            <td>{{ fee.value_show }}</td>
          </tr>
        </tbody>
      </table>
      <strong>{{ webTotalLegalText }}</strong> {{ webTotalLegalUrl }}
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Header from '@/components/header'
import Breadcrumbs from '@/components/widgets/cart-breadcrumbs'
import CheckoutTitle from '@/components/widgets/cart-title'

export default {
  data() {
    return {
      counter: 1
    }
  },
  components: {
    Header,
    Breadcrumbs,
    CheckoutTitle
  },
  computed: {
    ...mapGetters({
      signedIn: 'auth/signedIn',
      // cart: 'cart/cartItems',
      cart: 'cart/getCart',
      cartTotal: 'cart/cartTotalAmount',
      cartTax: 'cart/taxAmount',
      getDetail: 'products/getProductByProductId',
      webTotalDetails: 'cart/webTotalDetails',
      webTotalLines: 'cart/webTotalLines',
      webTotalTitle: 'cart/webTotalTitle',
      webTotalLegalText: 'cart/webTotalLegalText',
      webTotalLegalUrl: 'cart/webTotalLegalUrl',
      getBlockCheckout: 'cart/getBlockCheckout',
      getFreeDeliveryText: 'cart/getFreeDeliveryText',
      getIsFreeDelivery: 'cart/getIsFreeDelivery',
      getWarningText: 'cart/getWarningText',
      getLoaded: 'products/getLoaded',
      pending_delivery: 'auth/pending_delivery',
    })
  },
  mounted() {

  },
  methods: {
    add_promo_special_to_order: function (sku, promo_id) {
      // TODO: Add the backend
      this.$store.dispatch('cart/addPromoItem', { sku, promo_id})
    },
    removeCartItem: function (sku) {
      this.$store.dispatch('cart/removeCartItem', { sku })
    },
    // Example to set item.sku quantity
    updateCartItemQty: function (sku, qty) {
      this.$store.dispatch('cart/updateCartItemQty', { sku, qty })
    },
    increment(sku, qty = 1) {
      this.$store.dispatch('cart/updateCartItemQty', {
        sku,
        qty
      })
    },
    decrement(sku, qty = -1) {
      if (sku.qty + qty < 1) return
      this.$store.dispatch('cart/updateCartItemQty', {
        sku,
        qty
      })
    },
    editqty(sku, qty = 0) {
      if (sku.qty + qty < 1) return
      this.$store.dispatch('cart/updateCartItemQty', {
        sku,
        qty
      })
    }
  }
}
</script>

<style scoped>

.promo_percent_text {
  color: red;
}

</style>
